import { render } from "./CompanyReferralBaseForm.vue?vue&type=template&id=40fa6eae"
import script from "./CompanyReferralBaseForm.vue?vue&type=script&lang=js"
export * from "./CompanyReferralBaseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__